import Dexie from 'dexie';
import relationships from 'dexie-relationships';

const db = new Dexie('Contratos', { addons: [relationships] });

db.version(1).stores({
  farmers: '++id, id_external, code, name, identifier, phone, sync_status',
  fields: '++id, id_external, code, name, farmer -> farmers.id, surface, ownershipType, sync_status',
  crops: '++id, id_external, variety -> varieties.id, field -> fields.id, surface, campaign -> campaign.id, protocols, sync_status',
  ownershipTypes: 'id, name',
  dcs: 'code, name, dataType, required, entity, order, defaultValue',
  config: 'code, value',
  qprotocols: 'id, name',
  campaign: 'id, name',
  varieties: 'id, name, code',
  contracts: '++id, id_external, startDate, endDate, field -> fields.id, lines, validated, sync_status',
  countries: 'id, name',
  vatRate: 'id, code, name, clasification, business',
  retention: 'id, code, name',
  business: 'id, code, name',
  wayToPay: 'id, code, name',
  zones: 'id, code, name',
});

db.version(2).stores({
  contracts: '++id, id_external, startDate, endDate, field -> fields.id, lines, validated, images, sync_status',
});

db.version(3).stores({
  familiesOfVarieties: 'id, code, name',
});

db.version(4).stores({
  farmers: '++id, id_external, code, name, identifier, phone, vatRate -> vatRate.id, retention -> retention.id, business -> business.id, wayToPay -> wayToPay.id, sync_status',
});

db.open();

export default db;
